import * as yup from 'yup'

export const legalEntityWithRepresentativeValidationSchema = yup.object().shape({
    rcs: yup
        .string()
        .required('Le numéro RCS est requis')
        .matches(/^\d{9}$/, 'Le RCS doit contenir 9 chiffres'),
    companyName: yup
        .string()
        .required('Le nom de l\'entreprise est requis')
        .min(2, 'Le nom doit faire au moins 2 caractères'),
    legalForm: yup.string().required('La forme juridique est requise'),
    capital: yup
        .number()
        .required('Le capital est requis')
        .positive('Le capital doit être positif'),
    postalCode: yup
        .string()
        .required('Le code postal est requis')
        .matches(/^\d{5}$/, 'Le code postal doit contenir 5 chiffres'),
    city: yup.string().required('La ville est requise'),
    address: yup.string().required('L\'adresse est requise'),
    registrationOffice: yup.string().required('Le bureau d\'enregistrement est requis'),
    civility: yup.string().required('La civilité est requise'),
    lastName: yup.string().required('Le nom est requis'),
    firstName: yup.string().required('Le prénom est requis'),
});

export default legalEntityWithRepresentativeValidationSchema